import React, { useEffect } from "react";
import AlertData from "../api/AlertData";
import { ErrorListAlert } from "../components/alert/ErrorListAlert";
import RolesState from "../api/RolesState";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { BtnOutlineV4 } from "../components/UI/button/BtnOutlineV4";

const AlertCenter = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    if (RolesState.all_soft_client) {
      AlertData.calcError();
    }
  }, []);

  if (!RolesState.all_soft_client) {
    return null;
  }

  return (
    <div className="main-page company-card-v4 alert-center-v4">
      <header className="card header-card alert-center-header">
        <div className="header-top">
          <div className="company-title">
            <div className="compamy-title-name-container">
              <span className="req-label">Уведомления</span>
              <h1>Центр уведомлений</h1>
            </div>
          </div>
          <div className="alert-center-header-hint">
            <span className="alert-center-header-hint-text">
              Для изменения настроек перейдите в профиль
            </span>
            <BtnOutlineV4
              text="Перейти"
              onClick={() => navigate("/profile")}
            />
          </div>
        </div>
      </header>

      <section className="card reports-tab-panel alert-center-panel">
        <ErrorListAlert />
      </section>
    </div>
  );
});

export { AlertCenter };